import { h } from 'preact'
import logo from './logo.png'

export default ({ className }) => (
  <img src={logo} alt="rekonstrukce statu" className={className} />
)



// WEBPACK FOOTER //
// ./components/atoms/logo.js